const map = (
  input: number,
  input_start: number,
  input_end: number,
  output_start: number,
  output_end: number
) => {
  const slope = (output_end - output_start) / (input_end - input_start);
  const output = output_start + slope * (input - input_start);
  return output;
};

export default map;
